import React from 'react'
// import './Button.css' // nếu bạn muốn tách CSS riêng, không bắt buộc

export default function Button({
  children,
  onClick,
  type = "button",
  variant = "default",
  size = "default",
  className = "",
  disabled = false,
  ...rest
}) {
  const variantClass = {
    default: "bg-primary text-primary-foreground hover:bg-primary/90",
    destructive:
        "bg-destructive text-destructive-foreground hover:bg-destructive/90",
    outline:
        "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
    secondary:
        "bg-secondary text-secondary-foreground hover:bg-secondary/80",
    ghost: "hover:bg-accent hover:text-accent-foreground",
    link: "text-primary underline-offset-4 hover:underline",
  }[variant]

  const sizeClass = {
    default: "h-10 px-4 py-2 whitespace-nowrap",
    sm: "h-9 px-3 rounded-md whitespace-nowrap", 
    sm_cta: "h-9 px-3 whitespace-normal", 
    lg: "h-11 rounded-md px-8 whitespace-nowrap",
    icon: "h-10 w-10 whitespace-nowrap",
  }[size]

  const baseClass =
    "inline-flex items-center justify-center gap-2 text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0"

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${baseClass} ${variantClass} ${sizeClass} ${className}`}
      {...rest}
    >
      {children}
    </button>
  )
}
